import React from 'react'
//import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'
import IconButton from '@material-ui/core/IconButton'
import MenuIcon from '@material-ui/icons/Menu'
import * as routes from '../../constants/routes'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { doSignOut } from '../../firebase/auth'
import AppNotificationCounter from '../Notification/AppNotificationCounter'
import MailCounter from '../../Container/Counter/MailCounter'
//import MobNav from './MobNav'
const styles = {
  root: {
    flexGrow: 1,
  },
  flex: {
    flexGrow: 1,
  },
  menuButton: {
    marginLeft: -12,
  },
}

const MainAppBar = (props) =>{
 
  const { classes, onToggleDrawer, notificationCounter } = props
  return (
    <div className={classes.root}>
      <AppBar position="static">
        <Toolbar>
          <IconButton onClick={()=>onToggleDrawer(true)} className={classes.menuButton} color="inherit" aria-label="Menu">
            <MenuIcon/>
          </IconButton>
          <Typography variant="title" color="inherit" className={classes.flex}>
            Menu
          </Typography>
          <MailCounter counter={props.inboxCounter || 0} color='white' link='MY_MESSAGING_CENTER'/>
          <AppNotificationCounter color='white' notificationCounter={notificationCounter}/>
            {props.userState!==null
            ? <Link className='navLink' to={routes.LANDING} onClick={()=>doSignOut(props.userState.id)}><Button color="inherit">Abmelden</Button></Link>
            : <Link className='navLink' to={routes.SIGN_IN}><Button color="inherit">Anmelden</Button></Link>
            }
        </Toolbar>
      </AppBar>
    </div>
  )
}

const mapDispatchToProps = (dispatch) => ({
  onToggleDrawer: (value) => dispatch({type: 'TOGGLE_DRAWER', value})
})

const mapStateToProps = (state) => ({
  drawerState: state.appState.drawerState,
  notificationCounter: state.notificationState.notificationCounter,
  userState: state.userState.profile,
  inboxCounter: state.messagingState.inboxCounter
})
export default compose(
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps)
)(MainAppBar);


// WEBPACK FOOTER //
// ./src/Components/App/AppBar.js